import React from 'react';
import clsx from 'clsx';
import { Image, T, useTranslation } from '@colonist/ui';
import { emptyTranslation } from '@colonist/i18n';
import iconPencil from '@static/images/icon_pencil.svg';
import styles from './EditProfileHeader.module.scss';
/** Profile header showing the avatar, username, and optional edit pencil. */ export const EditProfileHeader = ({ username, icon, onEditClick })=>{
    const { t } = useTranslation();
    const isEditable = onEditClick != undefined;
    const editProfileLabel = t('strings:homePage.header.editProfile');
    const headerContent = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.identity
    }, /*#__PURE__*/ React.createElement(Image, {
        className: styles.icon,
        image: {
            src: icon,
            alt: emptyTranslation
        }
    }), /*#__PURE__*/ React.createElement("h2", {
        className: styles.username
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: username
            }
        }
    }))), isEditable && /*#__PURE__*/ React.createElement(Image, {
        className: styles.editIcon,
        image: {
            src: iconPencil,
            alt: 'strings:homePage.header.editProfile'
        }
    }));
    if (isEditable) {
        return /*#__PURE__*/ React.createElement("button", {
            className: clsx(styles.header, styles.editable),
            onClick: onEditClick,
            type: "button",
            "aria-label": editProfileLabel
        }, headerContent);
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.header
    }, headerContent);
};
